export default __webpack_public_path__ + "static/media/img-top-title-bg2.9267ef97.svg";